import React from 'react'
import { useInterviewTimer } from '../../contexts/InterviewTimerContext'

const ProgressBar: React.FC = () => {
    const { progressPercentage } = useInterviewTimer()

    return (
        <div className="info-container flex flex-col gap-2 justify-center w-full">
            <div className="progression-wrapper h-2 md:h-1.5 lg:h-2 xl:h-2 w-full bg-[rgb(202,243,203)] rounded-md">
                <div
                    className="progressbar h-full bg-green-500 rounded-md transition-all duration-300 ease-in-out"
                    style={{ width: `${progressPercentage}%` }}
                ></div>
            </div>
        </div>
    )
}

export default ProgressBar
